import { useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useAlert } from 'react-alert'

import {
  ConstrutosModel,
  TypeToAvaliacaoModel
} from '../../../../domain/models'
import { fetchConstructor, fetchTypeToService } from '../../../../main/usecases'

import { goToUrl } from '../../../utils'
import { useModalBox } from '../../../contexts'
import { Button, SelectInput } from '../../../components'

import * as S from './styles'

export type ConstrutosDataProps = {
  typeToService: number
  cdConstruto: number
}

const FilterCustomConstrutoModal = () => {
  const [loading, setLoading] = useState(false)
  const [typeToConstruto, setTypeToConstruto] = useState<ConstrutosModel[]>()
  const [typeToService, setTypeToService] = useState<TypeToAvaliacaoModel[]>()
  const [documentsData, setDocumentsData] = useState<ConstrutosDataProps>(
    {} as ConstrutosDataProps
  )
  const { modalClose } = useModalBox()
  const alert = useAlert()
  const history = useHistory()

  const optionsListConstrutos = useMemo(
    () =>
      typeToConstruto?.map((item) => {
        return {
          value: item?.cdConstruto,
          label: item?.construto
        }
      }),
    [typeToConstruto]
  )

  const optionsListServices = useMemo(
    () =>
      typeToService?.map((item) => {
        return { value: item?.cdTipoAvaliacao, label: item?.tipoAvaliacao }
      }),
    [typeToService]
  )

  const handleFilterCustomDocument = async (
    construto?: ConstrutosModel,
    typeToService?: TypeToAvaliacaoModel
  ) => {
    try {
      setLoading(true)

      goToUrl(history, `/construto`, {
        cdConstruto: construto && construto.cdConstruto,
        cdTypeToService: typeToService && typeToService.cdTipoAvaliacao,
        construtoTitle: construto && construto.construto,
        serviceTitle: typeToService && typeToService.tipoAvaliacao
      })

      modalClose(true)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao filtrar o construto personalizado', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    ;(async () => {
      try {
        const dataToTypeToDocuments = await fetchConstructor().load()
        const dataToTypeToServices = await fetchTypeToService().load()

        setTypeToConstruto(dataToTypeToDocuments)
        setTypeToService(dataToTypeToServices)
        setDocumentsData({
          cdConstruto: dataToTypeToDocuments[0].cdConstruto,
          typeToService: dataToTypeToServices[0].cdTipoAvaliacao
        })
      } catch (error) {
        console.error(error)
      }
    })()
  }, [])

  return (
    <S.ModalInfo>
      <SelectInput
        labelColor="#4F4F4F"
        label="Construto*"
        name="cdConstruto"
        onChange={(e: any) =>
          setDocumentsData((prev: any) => ({
            ...prev,
            cdConstruto: Number(e.target.value)
          }))
        }
        value={documentsData?.cdConstruto}
        options={optionsListConstrutos}
      />
      <SelectInput
        labelColor="#4F4F4F"
        label="Tipo do avaliação*"
        name="typeToService"
        onChange={(e: any) =>
          setDocumentsData((prev: any) => ({
            ...prev,
            typeToService: Number(e.target.value)
          }))
        }
        value={documentsData?.typeToService}
        options={optionsListServices}
      />
      <Button
        disabled={loading}
        onClick={() =>
          handleFilterCustomDocument(
            typeToConstruto?.find(
              (item) => item.cdConstruto === documentsData.cdConstruto
            ),
            typeToService?.find(
              (item) => item.cdTipoAvaliacao === documentsData.typeToService
            )
          )
        }
      >
        Filtrar
      </Button>
    </S.ModalInfo>
  )
}

export default FilterCustomConstrutoModal
